import { Component } from '@angular/core';
import { RecommendationContentEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Contents') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-recommendationcontent-form',
    templateUrl: './recommendationcontent.form.component.html'
})
export class RecommendationContentFormComponent extends BaseFormComponent {
    public record!: RecommendationContentEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'contributorContents', sectionName: 'Contributor Contents', isExpanded: false }
        ]);
    }
}

